export const JUST_ME: string = "private"
export const MY_FEED: string = "teams"
export const EVERYTHING: string = ""

interface SortOption {
  value: string
  label: string
}

export const SORT_OPTIONS: SortOption[] = [
  {value: EVERYTHING, label: "recognition.polls.filters.sortBy.options.everything"},
  {value: MY_FEED, label: "recognition.polls.filters.sortBy.options.myTeams"},
  {value: JUST_ME, label: "recognition.polls.filters.sortBy.options.justMe"}
]

export default {
  JUST_ME,
  MY_FEED,
  EVERYTHING,
  OPTIONS: SORT_OPTIONS
}
